import { render, staticRenderFns } from "./DamageHistory.vue?vue&type=template&id=742e2366"
import script from "./DamageHistory.vue?vue&type=script&lang=js"
export * from "./DamageHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports